// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".newsletterForm{position:relative}.newsletterForm__info{left:0;position:absolute;top:calc(100% + 10px);width:100%}.newsletterForm__input{border:1px solid #e6e6e6;border-radius:4px;margin-bottom:.5rem;margin-top:auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
